<script setup>
import { useLayout } from '@/layout/composables/layout';
import { useRouter } from 'vue-router';
import axios from '@/api/axios';
import { useStore } from 'vuex';

const { layoutState } = useLayout();
const router = useRouter();
const store = useStore();

// Fonction pour gérer la déconnexion
const handleLogout = async () => {
  try {
    // Récupère le refresh token du localStorage
    const refreshToken = localStorage.getItem('refreshToken');

    // Appel à l'API de déconnexion avec le refresh token
    if (refreshToken) {
      await axios.post('authV2/logout/', { refresh: refreshToken });
    }

    // Suppression des tokens du localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    store.dispatch('logout');

    // Redirection vers la page de connexion
    router.push('/auth/login');
    
    // Fermer la sidebar
    layoutState.profileSidebarVisible.value = false;
  } catch (error) {
    console.error('Erreur lors de la déconnexion:', error);
    // Gérer l'erreur (par exemple, afficher un message à l'utilisateur)
  }
};

// Fonction pour rediriger vers le profil
const goToProfile = () => {
  router.push('/profil');
  
  // Fermer la sidebar
  layoutState.profileSidebarVisible.value = false;
};
</script>


<template>
  <Sidebar v-model:visible="layoutState.profileSidebarVisible.value" position="right" class="layout-profile-sidebar w-full sm:w-25rem">
    <div class="flex flex-column mx-auto md:mx-0">
      <span class="mb-2 font-semibold">Bienvenue</span>
      <span class="text-color-secondary font-medium mb-5">Prénom NOM</span>

      <ul class="list-none m-0 p-0">
        <li>
          <a @click="goToProfile" class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
            <span>
              <i class="pi pi-user text-xl text-primary"></i>
            </span>
            <div class="ml-3">
              <span class="mb-2 font-semibold">Profil</span>
              <p class="text-color-secondary m-0">Gérez votre profil</p>
            </div>
          </a>
        </li>
        <li>
          <a @click="handleLogout" class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
            <span>
              <i class="pi pi-power-off text-xl text-primary"></i>
            </span>
            <div class="ml-3">
              <span class="mb-2 font-semibold">Se Déconnecter</span>
              <p class="text-color-secondary m-0">Déconnectez-vous.</p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </Sidebar>
</template>
